// -*- Mode: rjsx -*-
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Slide from '@mui/material/Slide';

import { FHMaterialStyles } from '../../../ui';

import { queueCelebrateFinish } from '..';


function Celebrate(props) {
    console.log(props);
    
    let timeout = null;
    const dispatch = useDispatch();
    const classes = FHMaterialStyles({ color: "#203f52" });
    
    useEffect(() => {
        if(!timeout) {
            timeout = setTimeout(() => dispatch(queueCelebrateFinish()), 750);
        }
    }, []);
    
    return (
        <Slide in={true} direction="up">
          <Box className={classes.celebrateContainer}>
            
            <Card className={classes.celebrateCard}>
              
              <CardMedia
                className={classes.celebrateMedia}
                image="/images/celebrate/f-burst-a.png"
                title="Thanks!"
              />
              
              <CardContent className={classes.celebrateContent}>
                <Typography className={classes.celebrateTitle} variant={'h2'}>
                  Thanks!
                </Typography>
                <Typography className={classes.celebrateSubtitle}></Typography>
              </CardContent>
              
            </Card>
            
          </Box>
        </Slide>
    );
    
}

export default Celebrate;
